const logs = {
    page_title: 'Registros de auditoría',
    title: 'Registros de auditoría',
    subtitle: 'Ver datos de registro de eventos de autenticación realizados por sus usuarios.',
    event: 'Evento',
    user: 'Usuario',
    application: 'Aplicación',
    time: 'Tiempo',
    filter_by: 'Filtrar por',
    last_1_hour: 'Última hora',
    last_24_hours: 'Últimas 24 horas',
    last_7_days: 'Últimos 7 días',
    last_30_days: 'Últimos 30 días',
    custom_range: 'Rango personalizado',
    from: 'Desde',
    to: 'Hasta',
};
export default Object.freeze(logs);
